import type { AnyObject } from '@/types/helpers.types';

export type TranslatableLabel = Record<Locale, string>;

/** Liste des locales acceptées dans l'application */
export enum Locale {
  fr = 'fr',
  en = 'en',
}

/**
 * Objet i18n "enrichi" permettant de définir la clé ainsi que des options appartenant à cette clé.
 * Utilisée notamment dans la validation de formulaires pour des validations asynchrones, par exemple.
 */
export type I18nKeyWithOptions<T extends AnyObject = AnyObject> = {
  /** Le chemin de la clé dans le dictionnaire */
  i18nKey: string;
  /**
   * objet optionnel de clé/valeurs retourné par le backend pour le problème spécifique et comportant des données
   * additionnelles permettant de personnaliser les messages.
   */
  options?: T;
  /**
   * clé optionnelle permettant de pluraliser les messages i18n en fonction de la valeur définie dans l'objet d'options
   * pour le nom de propriété fourni ici.  Attention, la valeur de la clé fournie doit être un type "number",
   * autrement vue-i18n interprétera une string (ou autre) comme une valeur "falsy" équivalant à 1.
   */
  pluralKey?: string;
};

export enum DayOfWeek {
  Sunday = 'sunday',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
}
